import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DeviceRepairStatus.css';
import Modal from '../Modal/Modal';
import CustomButton from '../CustomElements/CustomButton';
import TransferDeviceToRepair from './TransferDeviceToRepair';
import TransferDeviceToStorageFromRepair from './TransferDeviceToStorageFromRepair';
import TableMap from './TableMap';
// Кастомные хуки
import { useRole } from '../../customHook/useRole';
import useModalWithStatus from '../../customHook/useModalWithStatus';
import useDeviceStatus from '../../customHook/useDeviceStatus';
// Действия Redux
import { initStatusesFromServer } from '../../redux/actions/statuses.action';
import { STATUS } from '../../constants/status';

// компонент для отображения таблицы статусов ремонта устройства
// и обработки действий с ними.

function DeviceRepairStatus({ currentDevice, setActiveButton, activeButton, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  //проверяем роли пользователя
  const isMaster = useRole('master');

  //получаем массив статусов Хранение из стора
  const { repairStatuses } = useSelector((state) => state?.statuses);
  const [statusId, setStatusId] = useState('');

  const title = 'ИЗМЕНЕНИЕ ДАННЫХ СТАТУСА';

  // Получаем id статуса текущего устройства
  const deviceStatusId = currentDevice?.statusId;
  // Кнопка отключена, если статус не "Ремонт" (REPAIR = 11)
  const disabledBtn = deviceStatusId !== STATUS.REPAIR;

  // хук для получения текущего статуса по id
  const currentStatus = useDeviceStatus(repairStatuses, statusId);

  // Хук для управления модальным окном статусов
  const { isOpen, activeModal, closeModal, handleButtonClick } = useModalWithStatus(
    repairStatuses,
    currentDevice,
    setStatusId
  );

  // компоненты для отображения
  const contentData = {
    [t?.sendToRepair || 'Направление в ремонт']: (
      <TransferDeviceToRepair
        currentDevice={currentDevice}
        currentStatus={currentStatus}
        closeModal={closeModal}
        title={title}
        isEdit={true}
        t={t}
      />
    ),
    [t?.returnFromRepair || 'Возврат из ремонта']: (
      <TransferDeviceToStorageFromRepair
        currentDevice={currentDevice}
        currentStatus={currentStatus}
        closeModal={closeModal}
        title={title}
        isEdit={true}
        t={t}
      />
    ),
    [t?.statusReceiveForStorage || 'Принять на хранение']: (
      <TransferDeviceToStorageFromRepair currentDevice={currentDevice} closeModal={closeModal} t={t} />
    ),
  };

  // Инициализации статусов с сервера. принимает id устройства и тип статусов
  useEffect(() => {
    dispatch(initStatusesFromServer(currentDevice.id, 'repair'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* Таблица со статусами */}
      {repairStatuses && (
        <TableMap
          data={repairStatuses}
          handleButtonClick={handleButtonClick}
          currentDevice={currentDevice}
          setActiveButton={setActiveButton}
          activeButton={activeButton}
          t={t}
        />
      )}

      {/* Блок с кнопками */}
      {!isMaster && (
        <div className="device-repair-status_button-container">
          <CustomButton
            className="device-repair-status_button"
            text={t?.buttonStorage || 'Принять на хранение'}
            colorText="#FFFFF"
            onClick={() => handleButtonClick('Принять на хранение')}
            color={disabledBtn ? '#ADADAD' : ''}
            disabled={disabledBtn}
          />
        </div>
      )}

      {/* Модальное окно */}
      {isOpen && (
        <Modal isOpen={isOpen} onClose={closeModal} containerSelector={'.table-for-devices_or_uipps_container'}>
          {activeModal && contentData[activeModal]}
        </Modal>
      )}
    </>
  );
}

export default DeviceRepairStatus;
